import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/geoip',
    method: 'get',
    params
  })
}

export function getVerifyCount() {
  return request({
    url: '/geoip/verify/count',
    method: 'get'
  })
}

export function getVerifyCountMultiTemplate(data) {
  return request({
    url: `/geoip/verify/count?description=${data}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/geoip.js